import React from 'react';
import { useState } from 'react';
import './Photography.css';
import CloseIcon from '@material-ui/icons/Close';



const Photography = () => {
    let data = [{
        "id":1,
        "caption":"Solar Halo",
        "img":"https://i.ibb.co/N3LgW0v/20200717-120714.jpg"
    },
    {
        "id":2,
        "caption":"A Rickshaw Puller",
        "img":"https://i.ibb.co/x20YXH8/20200718-155454.jpg"
    },
    {
        "id":3,
        "caption":"House Of God",
        "img":"https://i.ibb.co/Zx11CPz/20210615-164517-1.jpg"
    },
    {
        "id":3,
        "caption":"Retro",
        "img":"https://i.ibb.co/qrmzVwp/20200731-111956.jpg"
    },
    {
        "id":4,
        "caption":"Childhood",
        "img":"https://i.ibb.co/hLSvz1Z/20200527-193037.jpg"
    },
    {
        "id":5,
        "caption":"A Bird",
        "img":"https://i.ibb.co/smpTybM/20200523-122129.jpg"
    },
    {
        "id":6,
        "caption":"Earphones",
        "img":"https://i.ibb.co/qpvRGdx/20200421-103104.jpg"
    },
    {
        "id":7,
        "caption":"Reflection",
        "img":"https://i.ibb.co/2cNxwQz/20200720-155948.jpg"
    },
    {
        "id":8,
        "caption":"A Mustard Flower",
        "img":"https://i.ibb.co/VBs281Y/20200114-160556-1.jpg"
    },
    {
        "id":9,
        "caption":"Horizon",
        "img":"https://i.ibb.co/NsDZbBS/20201228-223046-1.jpg"
    },
    {
        "id":10,
        "caption":"The Cycle",
        "img":"https://i.ibb.co/6ZdG1zn/20200214-165912.jpg"
    }]
    const [model, setModel] = useState(false);
    const [tempImgSrc, setTempImgSrc] =useState('');
    const getImg = (img) => {
        setTempImgSrc(img);
        setModel(true)
        

    }
    return (
        <>
        <div data-aos="zoom-in " className="mt-5 pt-5">
            <h2 style={{color:'white'}} className=" common">Photography</h2>
        <div className="common-border"></div>
            </div>
        <div data-aos="fade-right" className={model? "model open" : "model"}>
            <img src={tempImgSrc}/>
            <CloseIcon data-aos="fade-right" onClick={() => setModel(false)}></CloseIcon>

        </div>
        
       <div className="gallery">
           {
               data.map((item, index) => {
                   return(
                       <div className="pics" key={index} onClick={() => getImg(item.img)}>
                           <img src={item.img} style={{width:'100%'}}/>

                           </div>

                   )
               })
           }

       </div>
        
     
      </>
    )
};

export default Photography;





































// import { useEffect } from 'react';
// import FakeData from '../components/FakeData/FakeData.json';
// import Photo from './Photo';
// import '../components/Photography.css'





// const Photography = () => {
//     const [photos, setPhotos] = useState([])
//     useEffect(() => {
//         setPhotos(FakeData)
//     })
//     return (
//         <div className="containerr photo-card  pt-5 mt-5  ">
//             <h1 className="common mt-5" style={{color:"white"}}>Photography</h1>
//             <div className="common-border"></div>
//             <div className="pic row col-md-12 ">
                
//                 {
//                     photos.map(pic => <Photo  pic={pic}></Photo>)
//                 }
//             </div>
            
//         </div>
//     );
// };

// export default Photography;